import * as css from 'css/exports.module.scss';

import './SearchFilterContainer.scss';

import { Card, Row } from 'antd';
import React, { PropsWithChildren } from 'react';

export const SearchFilterContainer: React.FC<PropsWithChildren> = ({ children }) =>
	<Card className='periscope-search-filters'>
		<Row
			align='middle'
			gutter={ [ Number(css.size8), Number(css.size8) ] }>
			{ children }
		</Row>
	</Card>;

